import React from 'react';
import styled from 'styled-components';

import { overrideProperties } from '@ecp/common/src/style/utils';
import { sizePropTypes } from '@ecp/common/src/style/propTypes';
const CheckBoxComponent = (props) => {
  return <DefaultCheckbox {...props} />;
};

const DefaultCheckbox = styled.div`
  ${overrideProperties(sizePropTypes, { width: '22px', height: '22px' })}
  background: url(${(props) => props.theme.image.defaultChecked}) no-repeat;
  background-size: ${({ width }) => width || '22px'};
  box-sizing: border-box;
  flex-shrink: 0;

  &:hover {
    cursor: pointer;
  }

  &.checkbox-checked {
    background-image: url(${(props) => props.theme.image.defaultChecked});
  }

  &.checkbox-unchecked {
    background-image: url(${(props) => props.theme.image.defaultUnchecked});
  }

  &.checkbox-disabled {
    background-color: #dfdfdf;

    &:hover {
      cursor: not-allowed;
    }

    &.checkbox-checked {
      background-image: url(${(props) => props.theme.image.defaultDisabled});
    }

    &.checkbox-unchecked {
      background-image: none;
    }
  }
`;

export default CheckBoxComponent;
